module.exports = __webpack_public_path__ + "img/QiXie2.1045c338.png";